import { FieldModel, FieldModelObject } from './FieldModel'

export interface CustomerCreditCheckFormFields {
  addressLine1: FieldModel<string>
  addressLine2: FieldModel<string>
  birthDate: FieldModel<string>
  city: FieldModel<string>
  consent: FieldModel<boolean>
  firstName: FieldModel<string>
  lastName: FieldModel<string>
  legalNameCorrectlyRepresented: FieldModel<boolean>
  middleInitial: FieldModel<string>
  phone: FieldModel<string>
  ssn: FieldModel<string>
  state: FieldModel<string>
  zip: FieldModel<string>
}

export class CustomerCreditCheckFormFieldsObject implements CustomerCreditCheckFormFields {
  public addressLine1: FieldModel<string>
  public addressLine2: FieldModel<string>
  public birthDate: FieldModel<string>
  public city: FieldModel<string>
  public consent: FieldModel<boolean>
  public firstName: FieldModel<string>
  public lastName: FieldModel<string>
  public legalNameCorrectlyRepresented: FieldModel<boolean>
  public middleInitial: FieldModel<string>
  public phone: FieldModel<string>
  public ssn: FieldModel<string>
  public state: FieldModel<string>
  public zip: FieldModel<string>

  constructor() {
    this.addressLine1 = new FieldModelObject<string>('', 'addressLine1', 'Address', true, '^\\s*\\S+(?:\\s+\\S+){1,}')
    this.addressLine2 = new FieldModelObject<string>('', 'addressLine2', 'Address Two', false, '^[a-zA-Z0-9 .:-]{0,40}$')
    this.birthDate = new FieldModelObject<string>(
      '',
      'birthDate',
      'Date of Birth',
      true,
      '^(0?[1-9]|1[012])[\\/\\-](0?[1-9]|[12][0-9]|3[01])[\\/\\-]\\d{4}$',
      '##/##/####'
    )
    this.city = new FieldModelObject<string>('', 'city', 'City', true, '^([\\w\\. ]{2,})$')
    this.consent = new FieldModelObject<boolean>(false, 'consent', 'I have read and agree to the above statement.', true)
    this.firstName = new FieldModelObject<string>('', 'firstName', 'First Name', true, '^([\\w\\. ]{2,})$')
    this.lastName = new FieldModelObject<string>('', 'lastName', 'Last Name', true, '^([\\w\\. ]{2,})$')
    this.legalNameCorrectlyRepresented = new FieldModelObject<boolean>(
      true,
      'legalNameCorrectlyRepresented',
      'The name represented is my full legal name.',
      false
    )
    this.middleInitial = new FieldModelObject<string>('', 'middleInitial', 'Middle Initial', false, '^[a-zA-Z]?$', 'A')
    this.phone = new FieldModelObject<string>('', 'phone', 'Phone', true, '^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$', '(###) ###-####')
    this.ssn = new FieldModelObject<string>('', 'ssn', 'SSN', false, '^\\d{3}-\\d{2}-\\d{4}$', '###-##-####')
    this.state = new FieldModelObject<string>('', 'state', 'State', true, '^[a-zA-Z]{2}$', 'AA')
    this.zip = new FieldModelObject<string>('', 'zip', 'Zip Code', true, '(^\\d{5}$)|(^\\d{5}-\\d{4}$)', '#####')
  }
}



// WEBPACK FOOTER //
// ./src/typings/api-models/creditCheck/CustomerCreditCheckFormFields.ts